import range from './range'
import maxlength from './maxlength'
import rangelength from './rangelength'
import boolean from './boolean'
import halfKana from './halfKana'
export default {
  boolean,
  range,
  rangelength,
  maxlength,
  halfKana,
}
